export default class Job {
  handle (params) {
    //
  }

  run () {
    return this.handle(...arguments)
  }
}
